import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Typography, Grid } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import Pagination from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  hrLine: {
    border: 0,
    clear: "both",
    display: "block",
    width: "100%",
    backgroundColor: "lightgray",
    height: "1px",
  },
  heading: {
    minWidth: "120px",
    width: "auto",
    padding: 0,
  },
  headingGrid: {
    display: "flex",
    flexDirection: "row",
  },
  contentGrid: {
    marginTop: "1%",
    marginLeft: "3px",
  },
  expansionPanel: {
    border: "1px solid lightgrey",
  },
}));

export default function SearchedUserGuide(props) {
  const classes = useStyles();
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);
  const [page, setPage] = useState(1);
  const [noOfQuestions, setNoOfQuestions] = useState(6);
  const [count, setCount] = useState(1);
  const [noData, setNoData] = useState(false);
  const [actualData, setActualData] = useState("");
  const [details, setDetails] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [expanded, setExpanded] = React.useState(false);

  const handleChangeExpand = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (props.searchResult) {
      setFullData(props.searchResult);
      updateData(1, props.searchResult);
    }
  }, [props.searchResult]);

  const updateData = (page, data) => {
    if (data) {
      setNoData(false);
      setActualData(data);
      let details = [];

      let i = (page - 1) * noOfQuestions;
      for (i; i < page * noOfQuestions; i++) {
        if (i === data.length) break;
        details[i] = data[i];
      }
      const count = Math.floor(
        data.length / noOfQuestions +
          (data.length % noOfQuestions === 0 ? 0 : 1)
      );

      setCount(count);
      setDetails(details);
    } else {
      setNoData(true);
    }
  };

  const handleChange = (event, newPage) => {
    setPage(newPage);
    updateData(newPage, actualData);
  };

  return (
    <>
    <div class="margin-top-40"></div>
    <Grid container justify="center">
      {details.length > 0 ? (
        <React.Fragment>
          <Grid className={classes.headingGrid} item xs={12}>
            <Typography
              color="primary"
              variant="h6"
              component="h2"
              align="left"
              className={classes.heading}
            >
              <b>{labels?.SEARCH_USER_GUIDE}</b>
            </Typography>
            <hr className={classes.hrLine} />
          </Grid>

          <Grid
            className={classes.contentGrid}
            direction="column"
            spacing={2}
            container
            item
            alignItems="center"
            xs={12}
          >
            <Grid item spacing={4} container>
              {details.map((item, index) => {
                return (
                  <Grid key={index + 1} xs={12} sm={6} item>
                    <ExpansionPanel
                      className={classes.expansionPanel}
                      expanded={expanded === index}
                      onChange={handleChangeExpand(index)}
                    >
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography color="textPrimary">
                          {item._source.ContentTitle.length > 60 &&
                          expanded === false
                            ? item._source.ContentTitle.split(" ", 11).join(
                                " "
                              ) + " ..."
                            : item._source.ContentTitle}
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        {item._source.ContentGroupValue === "TEXT" ? (
                          <Typography color="textSecondary">
                            {item._source.ContentValue}
                          </Typography>
                        ) : (
                          <Typography
                            variant="h6"
                            align="center"
                            color="textSecondary"
                            dangerouslySetInnerHTML={{
                              __html: item._source.ContentValue,
                            }}
                          />
                        )}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Grid>
                );
              })}
            </Grid>
            {fullData.length > 6 ? (
              <Grid
                alignContent="center"
                alignItems="center"
                justify="center"
                item
                container
              >
                <Pagination
                  onChange={handleChange}
                  page={page}
                  count={count}
                  color="primary"
                />
              </Grid>
            ) : null}
          </Grid>
        </React.Fragment>
      ) : null}
    </Grid>
    </>
  );
}
